<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f mar_t20 mar_l20">
        <div class="pagetitle mar_b20">{{ $t('set.platform.title') }}</div>
      </div>
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item :label="$t('set.platform.name')" :required="true">
          <el-input v-model.trim="form.name" autocomplete="off" :placeholder="$t('set.platform.namePh')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('set.platform.platformId')" :required="true">
          <el-input v-model.trim="form.systemId" autocomplete="off" disabled :placeholder="$t('set.platform.namePh')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('set.platform.logo')" :required="true">
          <div class="uploadSource bor_de rel flex curs" v-if="form.icon">
            <label class="statusLabel curs" @mouseenter="enter(1)" @mouseleave="leave(1)">
              <i class="el-icon-check" ref="imgicon1"></i>
              <i class="el-icon-close" @click="deleteMultiImage(form.icon, 1)"></i>
            </label>
            <img :src="form.icon" @click="test(1)" class="wid" />
          </div>
          <div class="uploadSource flex-center curs" v-else @click="test(1)">
            <i class="el-icon-plus fon_40 color_d9"></i>
          </div>
          <attachment-img ref="img1" type="img" @attachment="imgadd1"></attachment-img>
        </el-form-item>
        <el-form-item :label="$t('set.platform.contact')" :required="true">
          <el-input v-model.trim="form.linkTel" autocomplete="off" :placeholder="$t('set.platform.contactPh')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('set.platform.txKey')" prop="txKey" :required="true">
          <el-input v-model.trim="form.txKey" autocomplete="off" :placeholder="$t('set.platform.txKeyPh')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('set.platform.intro')" :required="true">
          <el-input type="textarea" v-model.trim="form.introduction" :rows="4" :placeholder="$t('set.platform.introPh')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('set.platform.regAgreement')" :required="true">
          <baidu-ueditor :content="form.registrationAgreement" @ueditor="getUeditor($event, 'registrationAgreement')"></baidu-ueditor>
        </el-form-item>
        <el-form-item :label="$t('set.platform.management')" :required="true">
          <baidu-ueditor :content="form.management" @ueditor="getUeditor($event, 'management')"></baidu-ueditor>
        </el-form-item>
        <el-form-item :label="$t('set.platform.aboutUs')" :required="true">
          <baidu-ueditor :content="form.aboutUs" @ueditor="getUeditor($event, 'aboutUs')"></baidu-ueditor>
        </el-form-item>
      </el-form>
    </div>
    <div class="mar_t20 ba_f pad_20 t_c">
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
import baiduUeditor from '@/plugins/baidu-ueditor';
import attachmentImg from '@/plugins/attachment-img';
import { getConfig, postConfig } from '@/api/set';

export default {
  components: {
    attachmentImg,
    baiduUeditor
  },
  data() {
    return {
      form: {
        name: '',
        systemId: '',
        icon: '',
        linkTel: '',
        introduction: '',
        txKey: '',
        registrationAgreement: '',
        management: '',
        aboutUs: ''
      }
    };
  },
  created() {
    this.bus.$emit('loading', true);
    this.init();
  },
  methods: {
    ...mapMutations(['getPlatformInfo']),
    async init() {
      const { data } = await getConfig({ ident: 'system' });
      this.form = Object.assign({}, this.form, data);
      this.bus.$emit('loading', false);
    },
    getUeditor(content, key) {
      this.form[key] = content;
    },
    test(n) {
      this.$refs['img' + n].dialogVisible = true;
    },
    imgadd1(url) {
      this.form.icon = url.str;
    },
    enter() {},
    leave() {},
    deleteMultiImage() {
      this.form.icon = '';
    },
    async submitForm() {
      this.form.ident = 'system';
      const { msg } = await postConfig(this.form);
      this.$baseMessage(msg, 'success');
      const res = await getConfig({ ident: 'system' });
      this.getPlatformInfo(res.data);
    }
  }
};
</script>
